import { render, staticRenderFns } from "./InfoState.vue?vue&type=template&id=5638c5c2&scoped=true"
import script from "./InfoState.vue?vue&type=script&lang=ts"
export * from "./InfoState.vue?vue&type=script&lang=ts"
import style0 from "./InfoState.vue?vue&type=style&index=0&id=5638c5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638c5c2",
  null
  
)

export default component.exports